import { HorizontalSafeAreaContainer } from '../../../components';
import { useHorizontalSafeAreaHeaderOptions } from '../../../hooks';
import { ReorderConfirmLocationScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  useHorizontalSafeAreaHeaderOptions();

  return (
    <HorizontalSafeAreaContainer>
      <ReorderConfirmLocationScreen />
    </HorizontalSafeAreaContainer>
  );
}
